"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mpBaseUrlMiddleware = exports.mpGetBaseUrl = exports.mpGetFinalHostname = exports.getXHeaderValue = void 0;
/**
 * Get as single value (the first one for arrays) from a header
 * @param header
 */
function getXHeaderValue(header) {
    const value = header || "";
    let result;
    if (Array.isArray(value)) {
        result = value[0];
    }
    else {
        result = value;
    }
    if (result.includes(',')) {
        // x-forwarded-* headers are lists of all proxies separated by comma, and
        // this middleware always wants the outmost one (what was requested but the
        // initiating client)
        result = result.split(',')[0];
    }
    return result;
}
exports.getXHeaderValue = getXHeaderValue;
/**
 * Browsers do magical things with hostnames and ports, this method tries
 * to act like them so that the final hostname we have represents the host
 * that browsers send
 *
 * @param request
 */
function mpGetFinalHostname(request) {
    if (request.mpProto === "https" && request.mpPort === 443) {
        return request.mpHostname;
    }
    else if (request.mpProto === "http" && request.mpPort === 80) {
        return request.mpHostname;
    }
    else {
        return `${request.mpHostname}:${request.mpPort}`;
    }
}
exports.mpGetFinalHostname = mpGetFinalHostname;
/**
 * Get the full base url
 *
 * @param request
 */
function mpGetBaseUrl(request) {
    return `${request.mpProto}://${mpGetFinalHostname(request)}`;
}
exports.mpGetBaseUrl = mpGetBaseUrl;
function mpBaseUrlMiddleware() {
    return (request, response, next) => {
        const forwardedHost = getXHeaderValue(request.headers["x-forwarded-host"]);
        let hostname = forwardedHost || request.headers.host;
        if (!hostname) {
            throw new Error('Headers "x-forwarded-host" and "host" are empty. The base URL cannot be set.');
        }
        let port;
        if (hostname.indexOf(":") !== -1) {
            // Sometimes the host includes and sometimes not, entirely
            // up to the browser and proxies to decide
            port = hostname.split(":")[1];
            hostname = hostname.split(":")[0];
        }
        const forwardedPort = getXHeaderValue(request.headers["x-forwarded-port"]);
        port = port || forwardedPort || process.env.NUXT_PORT || process.env.PORT;
        if (!port) {
            throw new Error('Headers "x-forwarded-port" or env.PORT are empty. The base URL cannot be set.');
        }
        // We have to guess sadly, there doesn't seem to be another reliable way
        // anx x-* headers are optional
        const forwardedProto = getXHeaderValue(request.headers["x-forwarded-proto"]);
        const proto = forwardedProto || "http";
        const xHeaders = Object.fromEntries(Object.keys(request.headers)
            .filter((key) => /^x-forwarded-/i.test(key))
            .map((key) => {
            return [key.toLowerCase(), getXHeaderValue(request.headers[key])];
        })
            // filter out empty values
            .filter((tuple) => !!tuple[1]));
        request.mpHostname = hostname;
        request.mpPort = parseInt(port);
        request.mpProto = proto;
        request.mpXHeaders = xHeaders;
        request.mpGetFinalHostname = mpGetFinalHostname.bind(request);
        request.mpGetBaseUrl = mpGetBaseUrl.bind(request);
        return next();
    };
}
exports.mpBaseUrlMiddleware = mpBaseUrlMiddleware;
//# sourceMappingURL=index.js.map